<template>
  <v-card>
    <v-card-text>
      <h3>Capacitance</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Abfarad (abF)',
          val: 1
        },
        {
          text: 'Attofarad (aF)',
          val: 1e27
        },
        {
          text: 'Centifarad (cF)',
          val: 100000000000
        },
        {
          text: 'Coulomb per volt',
          val: 1000000000
        },
        {
          text: 'Decafarad (daF)',
          val: 100000000
        },
        {
          text: 'Decifarad (dF)',
          val: 10000000000
        },
        {
          text: 'Exafarad (EF)',
          val: 1e-9
        },
        {
          text: 'Farad (F)',
          val: 1000000000
        },
        {
          text: 'Femtofarad (fF)',
          val: 1e24
        },
        {
          text: 'Gigafarad (GF)',
          val: 1
        },
        {
          text: 'Hectofarad (hF)',
          val: 10000000
        },
        {
          text: 'Kilofarad (kF)',
          val: 1000000
        },
        {
          text: 'Megafarad (MF)',
          val: 1000
        },
        {
          text: 'Microfarad (µF)',
          val: 1000000000000000
        },
        {
          text: 'Millifarad (mF)',
          val: 1000000000000
        },
        {
          text: 'Nanofarad (nF)',
          val: 1000000000000
        },
        {
          text: 'Petafarad (PF)',
          val: 0.000001
        },
        {
          text: 'Picofarad (pF)',
          val: 1e21
        },
        {
          text: 'Statfarad (statF)',
          val: 898755178736500000000
        },
        {
          text: 'Terafarad (TF)',
          val: 0.001
        },
        {
          text: 'Yoctofarad (yF)',
          val: 1e33
        },
        {
          text: 'Yottafarad (YF)',
          val: 1e-15
        },
        {
          text: 'Zeptofarad (zF)',
          val: 1e30
        },
        {
          text: 'Zettafarad (ZF)',
          val: 1e-12
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// capacitance.vue?335ce901